import request from "./request";
import store from "../../store";
import toastr from "toastr";

export default {
  getCart({ commit, state }) {
    return new Promise((resolve, reject) => {
      request
        .getCart()
        .then((data) => {
          var total = 0;
          Object.keys(data).forEach(function (key) {
            data[key].mounted_courses=JSON.parse(data[key].mounted_courses);
            total = total + Number(data[key].mounted_courses.price);
          });
          commit("SET_CART", data);
          commit("SET_PRICE", total);

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  addCart({ commit, state }, item) {
    return new Promise((resolve, reject) => {
      // IF LOGED SET CART ONLY EN STORE 
      if (!store.state.auth.isLoggedIn) {
        commit("ADD_CART", item);
        resolve()
        return
      }

      request
        .addCart(item.id)
        .then((data) => {

          if (data['code'] == 22) {
            toastr.warning('Ya se encuentra registrado en este curso')
            return
          }

          commit("SET_CART", data);
          var total = 0;
          var carS = data;

          Object.keys(carS).forEach(function (key) {
            total = total + Number(carS[key].mounted_courses.data.price);
          });
          commit("SET_PRICE", total);

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  upNoLogedCart({ dispatch, state }) {
    if (state.cart != 0) {
      toastr.warning('Agregando courses al carrito...')
      let aux = []
      state.cart.forEach(element => {
        aux.push(dispatch('addCart', element))
      })

      Promise.all(aux).then(data => {
        store.dispatch('course/getCourses')
      })
    }
  },

  delCart({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      request
        .delCart(id)
        .then((data) => {
          commit("SET_CART", data);
          var total = 0;
          var carS = data;

          Object.keys(carS).forEach(function (key) {
            total = total + Number(carS[key].mounted_courses.data.price);
          });
          commit("SET_PRICE", total);

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  clearCart({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      request
        .clearCart()
        .then((data) => {
          commit("SET_CART", data);
          commit("SET_PRICE", total);

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

};
